@if (discrete) {
  <div class="mdc-slider__value-indicator-container" #valueIndicatorContainer>
    <div class="mdc-slider__value-indicator">
      <span class="mdc-slider__value-indicator-text">{{valueIndicatorText}}</span>
    </div>
  </div>
}
<div class="mdc-slider__thumb-knob" #knob></div>
<div matRipple class="mat-mdc-focus-indicator" [matRippleDisabled]="true"></div>
